import { Component } from '@angular/core';

const SIGNUP_REVIEWS = [
  {
    name: 'Sandra Chan',
    review: `It helps me save a lot of time and I don't have to be constantly on my phone`,
    image: 'https://hospitable.com/wp-content/uploads/2024/07/Sandra.jpg',
  },
  {
    name: 'Ryan Johnson',
    review: `Automates all of the tasks I don't want to deal with myself.`,
    image: 'https://hospitable.com/wp-content/uploads/2024/07/Ryan-1.jpg',
  },
  {
    name: 'Zeona McIntyre',
    review: `We love the peace and quiet of limited guest messages that we must manually respond to!`,
    image: 'https://hospitable.com/wp-content/uploads/2024/07/Zeona-1.jpg',
  },
  {
    name: 'Tracey Choy',
    review: `Hospitable's a no brainer if you have more than two properties.`,
    image: 'https://hospitable.com/wp-content/uploads/2024/07/Tracey.jpg',
  },
  {
    name: 'Taylor Adams',
    review: `I love that I can send out automated emails about orphan nights and increase our revenue.`,
    image: 'https://hospitable.com/wp-content/uploads/2024/07/Taylor-400x400.jpg',
  },
  {
    name: 'Kareem Sargeant',
    review: `Favorite, favorite feature is the smart locks integrations.`,
    image: 'https://hospitable.com/wp-content/uploads/2024/07/Kareem-1-400x400.jpg',
  },
];

@Component({
  selector: 'sbnb-review-carousel',
  templateUrl: './review-carousel.component.html',
  styleUrls: ['./review-carousel.component.scss'],
})
export class ReviewCarouselComponent {
  reviews = SIGNUP_REVIEWS;
}
